import { render, staticRenderFns } from "./setChooseOrInputByVoiceSimulation.vue?vue&type=template&id=3d86270e&scoped=true"
import script from "./setChooseOrInputByVoiceSimulation.vue?vue&type=script&lang=js"
export * from "./setChooseOrInputByVoiceSimulation.vue?vue&type=script&lang=js"
import style0 from "./setChooseOrInputByVoiceSimulation.vue?vue&type=style&index=0&id=3d86270e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d86270e",
  null
  
)

export default component.exports